import { memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import { StickyDiv } from 'shell/components/shared/sticky-div';

interface ButtonsPageProps {
  handleExit: () => void;
}

const ButtonsPageComponent = ({ handleExit }: ButtonsPageProps): React.ReactElement => {
  return (
    <StickyDiv>
      <StepButton active fullWidth>
        <StepTypography active>Stato Civile</StepTypography>
      </StepButton>
      <div className="pmi-pt-4">
        <div className="pmi-pb-2">
          <PmiButton color="cdmBrandThird" variant="outlined" fullWidth type="submit">
            Conferma
          </PmiButton>
        </div>
        <div className="pmi-pb-2">
          <PmiButton color="cdmBrandThird" variant="outlined" fullWidth type="reset" id="reset">
            Ripulisci
          </PmiButton>
        </div>
        <div className="pmi-pb-2">
          <PmiButton color="cdmBrand" variant="contained" fullWidth onClick={handleExit}>
            Annulla Operazione
          </PmiButton>
        </div>
      </div>
    </StickyDiv>
  );
};

ButtonsPageComponent.displayName = 'Buttons Page component';

const ButtonsPage = memo(ButtonsPageComponent);

export default ButtonsPage;
